export const zhCNAgentGuiProjectLaunch = {
  projectLocked: "会话开始后项目不可更改",
  projectMissingDescription: "此对话的工作目录已不存在",
  sessionLaunchModeLabel: "会话启动方式",
  sessionLaunchModeLocal: "本地",
  sessionLaunchModeWorktree: "新工作树"
};
